import { push } from "react-router-redux";
import { put } from "redux-saga/effects";

export function* onLoginSaga() {
  yield put(push("/"));
}
